<template>
  <div :id="this.id">

  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "PotenciometreChart",
  props:{
    percentatge: Number,
    id: String
  },
  data() {
    return {
      width: 400,
      height: 400,
      angularWidth : [Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10,
                      Math.PI*0.10],
      colors : [d3.schemeCategory10[3],
                d3.schemeCategory10[3],
                d3.schemeCategory10[3],
                d3.schemeCategory10[3],
                d3.schemeCategory10[3],
                d3.schemeCategory10[1],
                d3.schemeCategory10[1],
                d3.schemeDark2[5],
                d3.schemeDark2[5],
              d3.schemeCategory10[2]]
    };
  },
  methods: {
    startAngle(d){
      var startAngle = -Math.PI/2
      var i = 0;
      while(i<d){
          startAngle = startAngle + this.angularWidth[i];
          i++;
      }
      return startAngle;
    },
    generateChart() {
            
      var svg = d3.select("#"+this.id)
      .append("svg").attr("width", this.width).attr("height", this.height)
      .append("g")//.attr("transform", "translate(0,20)");

      var i =0;
      for (i = 0; i < 10; i++) {
        svg.append("path")
        .attr("transform", "translate(200,200)")
        .attr("d", d3.arc()
          .innerRadius( 50 )
          .outerRadius( 150 )
          .endAngle( this.startAngle(i) +  this.angularWidth[i])     // It's in radian, so Pi = 3.14 = bottom.
          .startAngle( this.startAngle(i) )       // 2*Pi = 6.28 = top
          )
        .attr('stroke', 'white')
        .attr('fill', this.colors[i]);
      }
      //Indicador
      svg.append("path")
        .attr("transform", "translate(200,200)")
        .attr("d", d3.arc()
          .innerRadius( 0 )
          .outerRadius( 155 )
          .endAngle( -Math.PI/2 +Math.PI*(this.percentatge*10/100)+0.03)
          .startAngle( -Math.PI/2+Math.PI*(this.percentatge*10/100)-0.03 )
          )
        .attr('stroke', 'black')
        .style("opacity", 0.8)
        .attr('fill', d3.schemeDark2[7]);

      svg.append('text').call(text => text.append("tspan")
                        .attr("y", "0")
                        .attr("font-weight", "bold")
                        .attr("font-size","12")  
                        .attr("font-weight", "bold")
                        .attr("fill-opacity", 0.8)                             
                        .text( "0")).attr('transform', 'translate(30,200)');
      svg.append('text').call(text => text.append("tspan")
                        .attr("y", "0")
                        .attr("font-size","12")  
                        .attr("font-weight", "bold")
                        .attr("fill-opacity", 0.8)                         
                        .text( "10")).attr('transform', 'translate(360,200)');
      svg.append('text').call(text => text.append("tspan")
                        .attr("y", "0")
                        .attr("font-weight", "bold")
                        .style("opacity", 0.8)
                        .text( this.percentatge)).attr('transform', 'translate(195,220)');
      

    }

  },
  mounted() {    
    this.generateChart();
  }
};
</script>

<style>
</style>